import { LINK_DISPLAY_OPTIONS, type LinkDisplayChoice } from '../links/linkDisplay'

/**
 * The one switch between how a link is shown: Pill, Row or Preview. The card, the preview sheet and the chip's bar render it
 * here; a row inside the editor builds the same markup from the same list (links/linkUnitDecoration.ts), and design/studio/link-notes.css
 * draws both. Choosing the option already shown does nothing.
 */
export function LinkDisplaySwitch({ value, onChange, labels, groupLabel = 'Show link as', showLabels = false }: {
  value: LinkDisplayChoice; onChange: (choice: LinkDisplayChoice) => void
  /** The Links screen names the same three looks for a whole list (Names, List, Cards). */
  labels?: Readonly<Record<LinkDisplayChoice, string>>; groupLabel?: string
  /** The words beside the icons: in a menu there is room for them. */
  showLabels?: boolean
}) {
  return <span className={showLabels ? 'link-display-switch link-display-switch--labelled' : 'link-display-switch'} role="radiogroup" aria-label={groupLabel}>
    {LINK_DISPLAY_OPTIONS.map(([choice, label]) => <button key={choice} type="button" role="radio" aria-checked={value === choice}
      aria-label={labels?.[choice] ?? label} title={labels?.[choice] ?? label} data-link-display={choice} onClick={() => { if (value !== choice) onChange(choice) }}>{showLabels ? labels?.[choice] ?? label : null}</button>)}
  </span>
}
